import {Component, OnInit, input, signal, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-inspector-section",
    templateUrl: "./inspector-section.component.html",
    styleUrls: ["./inspector-section.component.scss"],
})
export class InspectorSectionComponent implements OnInit {
    readonly $allowOverflow = input<boolean>(false, {alias: "allowOverflow"})
    readonly $collapsable = input<boolean>(false, {alias: "collapsible"})
    readonly $isCollapsed = signal<boolean>(true)

    toggle() {
        this.$isCollapsed.set(!this.$isCollapsed())
    }

    ngOnInit(): void {}
}
